import { IBrandVenueAccess } from 'src/types';
import { EMAIL_VALIDATION_REGEX } from 'src/constants/regex';
import { IFormValues } from './types';

const isCompleteEntry = (entry: IBrandVenueAccess): boolean =>
  entry.access === 'specific' ? (entry.venue_ids?.length ?? 0) > 0 : true;

export const validateAccessControls = (data: IFormValues): boolean => {
  if (!data.role) {
    return false;
  }

  const brands = data.brands || [];
  const venueAccess = data.venue_access || [];

  if (brands.includes('*')) {
    return venueAccess.length === 0;
  }

  const coveredBrands = new Set(venueAccess.map((entry) => entry.brand_id));
  const grantedBrands = new Set(brands);

  return (
    brands.every((brandId) => coveredBrands.has(brandId)) &&
    venueAccess.every((entry) => grantedBrands.has(entry.brand_id) && isCompleteEntry(entry))
  );
};

export const validateUserForm = (data: IFormValues, venueAccessEnabled = true): boolean => {
  const hasFirstName = !!data.first_name?.trim().length;
  const hasLastName = !!data.last_name?.trim().length;
  const hasValidEmail = !!(data.email && EMAIL_VALIDATION_REGEX.test(data.email));
  const hasIdentity = hasFirstName && hasLastName && hasValidEmail;

  // With venue access management off, the venue coverage rules do not apply —
  // only the role is required alongside the identity fields.
  if (!venueAccessEnabled) {
    return hasIdentity && !!data.role;
  }

  return hasIdentity && validateAccessControls(data);
};
